import { AxiosResponse } from "axios";
import RequestUtilitario, { QueryBasicaParam } from "../../../../Utils/RequisicaoUtilitario";
import PagamentoTipo from "../../../../Models/Financeiro/Titulo/Pagamento/PagamentoTipo";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";

export function usePagamentoTipoListar({
    pagamentoTipo,
    ativo,
    select,
    queryKey,
    ...rest
}:QueryBasicaParam<AxiosResponse<PagamentoTipo[]>, PagamentoTipo[], {
    pagamentoTipo?:PagamentoTipo;
    ativo?:boolean;
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...pagamentoTipo,
        ativo
    });
    
    return useQuery({
        ...rest,
        queryKey : [ "Financeiro.Titulo.Pagamento.PagamentoTipo.Listar", `Financeiro.Titulo.Pagamento.PagamentoTipo.Listar?${queryString}` ],
        queryFn : () => Axios.get<PagamentoTipo[]>(`financeiro/titulo/pagamento/pagamentoTipo?${queryString}`),
        select : (response) => {
            if (select) return select(response);

            return response.data;
        }
    });
}